// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface ReactionEmojiRead
 */
export interface ReactionEmojiRead {
  /**
   *
   */
  emoji: string;
  /**
   *
   */
  users?: Array<User>;
}

/**
 * Check if a given object implements the ReactionEmojiRead interface.
 */
export function instanceOfReactionEmojiRead(value: object): value is ReactionEmojiRead {
  if (!("emoji" in value) || value["emoji"] === undefined) return false;
  return true;
}

export function ReactionEmojiReadFromJSON(json: any): ReactionEmojiRead {
  return ReactionEmojiReadFromJSONTyped(json, false);
}

export function ReactionEmojiReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ReactionEmojiRead {
  if (json == null) {
    return json;
  }
  return {
    emoji: json["emoji"],
    users: json["users"] == null ? undefined : (json["users"] as Array<any>).map(UserFromJSON),
  };
}

export function ReactionEmojiReadToJSON(json: any): ReactionEmojiRead {
  return ReactionEmojiReadToJSONTyped(json, false);
}

export function ReactionEmojiReadToJSONTyped(
  value?: ReactionEmojiRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    emoji: value["emoji"],
    users: value["users"] == null ? undefined : (value["users"] as Array<any>).map(UserToJSON),
  };
}
